export const investmentConstants = {
  // USER's ACCOUNTS
  UPDATE_USER_ACCOUNTS: "UPDATE_USER_ACCOUNTS",

  RESET_INVESTMENT: "RESET_INVESTMENT",

  // GENERAL
  FETCH_ACTIVED_FUNDS_START: "FETCH_ACTIVED_FUNDS_START",
  FETCH_ACTIVED_FUNDS_SUCCESS: "FETCH_ACTIVED_FUNDS_SUCCESS",
  FETCH_ACTIVED_FUNDS_FAILURE: "FETCH_ACTIVED_FUNDS_FAILURE",

  FETCH_ALL_FUNDS_START: "FETCH_ALL_FUNDS_START",
  FETCH_ALL_FUNDS_SUCCESS: "FETCH_ALL_FUNDS_SUCCESS",
  FETCH_ALL_FUNDS_FAILURE: "FETCH_ALL_FUNDS_FAILURE",

  FETCH_ALL_FUND_CODES_START: "FETCH_ALL_FUND_CODES_START",
  FETCH_ALL_FUND_CODES_SUCCESS: "FETCH_ALL_FUND_CODES_SUCCESS",
  FETCH_ALL_FUND_CODES_FAILURE: "FETCH_ALL_FUND_CODES_FAILURE",

  // PORTFOLIOS
  UPDATE_PORTFOLIOS_QUERIES: "UPDATE_PORTFOLIOS_QUERIES",
  FETCH_PORTFOLIOS_START: "FETCH_PORTFOLIOS_START",
  FETCH_PORTFOLIOS_SUCCESS: "FETCH_PORTFOLIOS_SUCCESS",
  FETCH_PORTFOLIOS_FAILURE: "FETCH_PORTFOLIOS_FAILURE",

  FETCH_NAV_PORTFOLIO_START: "FETCH_NAV_PORTFOLIO_START",
  FETCH_NAV_PORTFOLIO_SUCCESS: "FETCH_NAV_PORTFOLIO_SUCCESS",
  FETCH_NAV_PORTFOLIO_FAILURE: "FETCH_NAV_PORTFOLIO_FAILURE",

  // PORTFOLIO STATISTICS
  FETCH_PREVIOUS_RETURN_BY_ACCOUNT_START:
    "FETCH_PREVIOUS_RETURN_BY_ACCOUNT_START",
  FETCH_PREVIOUS_RETURN_BY_ACCOUNT_SUCCESS:
    "FETCH_PREVIOUS_RETURN_BY_ACCOUNT_SUCCESS",
  FETCH_PREVIOUS_RETURN_BY_ACCOUNT_FAILURE:
    "FETCH_PREVIOUS_RETURN_BY_ACCOUNT_FAILURE",

  FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_START:
    "FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_START",
  FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_SUCCESS:
    "FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_SUCCESS",
  FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_FAILURE:
    "FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_FAILURE",

  FETCH_HISTORY_GRAPH_BY_ACCOUNT_START: "FETCH_HISTORY_GRAPH_BY_ACCOUNT_START",
  FETCH_HISTORY_GRAPH_BY_ACCOUNT_SUCCESS:
    "FETCH_HISTORY_GRAPH_BY_ACCOUNT_SUCCESS",
  FETCH_HISTORY_GRAPH_BY_ACCOUNT_FAILURE:
    "FETCH_HISTORY_GRAPH_BY_ACCOUNT_FAILURE",

  FETCH_MONTHLY_RETURN_BY_ACCOUNT_START:
    "FETCH_MONTHLY_RETURN_BY_ACCOUNT_START",
  FETCH_MONTHLY_RETURN_BY_ACCOUNT_SUCCESS:
    "FETCH_MONTHLY_RETURN_BY_ACCOUNT_SUCCESS",
  FETCH_MONTHLY_RETURN_BY_ACCOUNT_FAILURE:
    "FETCH_MONTHLY_RETURN_BY_ACCOUNT_FAILURE",

  FETCH_PROFIT_BY_ACCOUNT_START: "FETCH_PROFIT_BY_ACCOUNT_START",
  FETCH_PROFIT_BY_ACCOUNT_SUCCESS: "FETCH_PROFIT_BY_ACCOUNT_SUCCESS",
  FETCH_PROFIT_BY_ACCOUNT_FAILURE: "FETCH_PROFIT_BY_ACCOUNT_FAILURE",

  FETCH_VOLATILITY_BY_ACCOUNT_START: "FETCH_VOLATILITY_BY_ACCOUNT_START",
  FETCH_VOLATILITY_BY_ACCOUNT_SUCCESS: "FETCH_VOLATILITY_BY_ACCOUNT_SUCCESS",
  FETCH_VOLATILITY_BY_ACCOUNT_FAILURE: "FETCH_VOLATILITY_BY_ACCOUNT_FAILURE",

  FETCH_MAX_DRAWDOWN_BY_ACCOUNT_START: "FETCH_MAX_DRAWDOWN_BY_ACCOUNT_START",
  FETCH_MAX_DRAWDOWN_BY_ACCOUNT_SUCCESS:
    "FETCH_MAX_DRAWDOWN_BY_ACCOUNT_SUCCESS",
  FETCH_MAX_DRAWDOWN_BY_ACCOUNT_FAILURE:
    "FETCH_MAX_DRAWDOWN_BY_ACCOUNT_FAILURE",

  FETCH_DRAWDOWN_BY_ACCOUNT_START: "FETCH_DRAWDOWN_BY_ACCOUNT_START",
  FETCH_DRAWDOWN_BY_ACCOUNT_SUCCESS: "FETCH_DRAWDOWN_BY_ACCOUNT_SUCCESS",
  FETCH_DRAWDOWN_BY_ACCOUNT_FAILURE: "FETCH_DRAWDOWN_BY_ACCOUNT_FAILURE",

  SET_DEFAULT_PORT_STAT: "SET_DEFAULT_PORT_STAT",
  CLEAR_DEFAULT_PORT_STAT: "CLEAR_DEFAULT_PORT_STAT",

  FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_SUCCESS:
    "FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_SUCCESS",
  FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_FAILURE:
    "FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_FAILURE",

  // LOT
  UPDATE_LOT_QUERIES: "UPDATE_LOT_QUERIES",
  FETCH_LOTS_START: "FETCH_LOTS_START",
  FETCH_LOTS_SUCCESS: "FETCH_LOTS_SUCCESS",
  FETCH_LOTS_FAILURE: "FETCH_LOTS_FAILURE",

  FETCH_NAVS_LOTS_START: "FETCH_NAVS_LOTS_START",
  FETCH_NAVS_LOTS_SUCCESS: "FETCH_NAVS_LOTS_SUCCESS",
  FETCH_NAVS_LOTS_FAILURE: "FETCH_NAVS_LOTS_FAILURE",

  // BOOK
  UPDATE_BOOK_QUERIES: "UPDATE_BOOK_QUERIES",
  FETCH_BOOKS_START: "FETCH_BOOKS_START",
  FETCH_BOOKS_SUCCESS: "FETCH_BOOKS_SUCCESS",
  FETCH_BOOKS_FAILURE: "FETCH_BOOKS_FAILURE",

  // DIVIDEND
  UPDATE_DIVIDEND_QUERIES: "UPDATE_DIVIDEND_QUERIES",

  FETCH_DIVIDENDS_START: "FETCH_DIVIDENDS_START",
  FETCH_DIVIDENDS_SUCCESS: "FETCH_DIVIDENDS_SUCCESS",
  FETCH_DIVIDENDS_FAILURE: "FETCH_DIVIDENDS_FAILURE",

  // HISTORIES
  UPDATE_INVESTMENT_HISTORIES_QUERIES: "UPDATE_INVESTMENT_HISTORIES_QUERIES",

  FETCH_HISTORIES_START: "FETCH_HISTORIES_START",
  FETCH_HISTORIES_SUCCESS: "FETCH_HISTORIES_SUCCESS",
  FETCH_HISTORIES_FAILURE: "FETCH_HISTORIES_FAILURE",

  FETCH_HISTORIES_CHANGE_PAGE: "FETCH_HISTORIES_CHANGE_PAGE",

  // DCA
  UPDATE_INVESTMENT_DCA_QUERIES: "UPDATE_INVESTMENT_DCA_QUERIES",
  DELETE_DCA_ORDER_REQUEST_START: "DELETE_DCA_ORDER_REQUEST_START",
  DELETE_DCA_ORDER_REQUEST_SUCCESS: "DELETE_DCA_ORDER_REQUEST_SUCCESS",
  DELETE_DCA_ORDER_REQUEST_FAILURE: "DELETE_DCA_ORDER_REQUEST_FAILURE",
  CLEAR_DCA_ORDER_ERROR_MESSAGE: "CLEAR_DCA_ORDER_ERROR_MESSAGE",

  FETCH_DCAS_START: "FETCH_DCAS_START",
  FETCH_DCAS_SUCCESS: "FETCH_DCAS_SUCCESS",
  FETCH_DCAS_FAILURE: "FETCH_DCAS_FAILURE",

  // ORDERS
  DELETE_ORDER_REQUEST_START: "DELETE_ORDER_REQUEST_START",
  DELETE_ORDER_REQUEST_SUCCESS: "DELETE_ORDER_REQUEST_SUCCESS",
  DELETE_ORDER_REQUEST_FAILURE: "DELETE_ORDER_REQUEST_FAILURE",
  FETCH_ORDERS_START: "FETCH_ORDERS_START",
  FETCH_ORDERS_SUCCESS: "FETCH_ORDERS_SUCCESS",
  FETCH_ORDERS_FAILURE: "FETCH_ORDERS_FAILURE",
  UPDATE_ORDERS_QUERIES: "UPDATE_ORDERS_QUERIES",
  CLEAR_ORDER_ERROR_MESSAGE: "CLEAR_ORDER_ERROR_MESSAGE",

  // INVESTMENT
  SET_INVEST_SEARCH: "SET_INVEST_SEARCH",
};

export const TRADE_TYPES = {
  SWITCH: "W",
  DCA: "DCA",
};

export const INVESTMENT_STATUS = {
  STATUS_P: "P",
  STATUS_A: "A",
  STATUS_I: "I",
};
